import { cn } from "@/lib/utils"
import type { ReactNode } from "react"

interface PageHeaderProps {
  eyebrow?: ReactNode
  title: ReactNode
  description?: ReactNode
  actions?: ReactNode
  meta?: ReactNode
  // When `true`, the actions column stretches to the same height as the
  // title block. Lets callers anchor secondary content (KPIs, hint text)
  // to the bottom of the header instead of clinging to the top.
  stretchActions?: boolean
}

export function PageHeader({
  eyebrow,
  title,
  description,
  actions,
  meta,
  stretchActions,
}: PageHeaderProps) {
  return (
    <div
      className={cn(
        "flex flex-col gap-3 sm:flex-row sm:justify-between",
        stretchActions ? "sm:items-stretch" : "sm:items-start",
      )}
    >
      <div className="space-y-1">
        {eyebrow ? (
          <p className="text-muted-foreground text-[11px] font-semibold uppercase tracking-wide">
            {eyebrow}
          </p>
        ) : null}
        <div className="flex flex-wrap items-center gap-2">
          <h1 className="text-3xl font-semibold tracking-tight">{title}</h1>
          {meta}
        </div>
        {description ? (
          <p className="text-muted-foreground text-sm">{description}</p>
        ) : null}
      </div>
      {actions ? (
        <div
          className={cn(
            "flex flex-wrap gap-2",
            stretchActions ? "sm:flex-col sm:flex-nowrap" : "",
          )}
        >
          {actions}
        </div>
      ) : null}
    </div>
  )
}
